import { useSyncExternalStore } from "react";
import api from "./api";

// Live JSON stream of every /disaster API call (request + response, big base64 fields trimmed) for the API inspector panel.
let entries = []; let seq = 0; const subs = new Set();
const emit = () => subs.forEach((f) => f());
const trim = (v, depth = 0) => {
  if (typeof v === "string") return v.length > 160 ? `<${v.length} chars>` : v;
  if (Array.isArray(v)) return v.length > 40 ? [...v.slice(0, 40).map((x) => trim(x, depth + 1)), `… +${v.length - 40} more`] : v.map((x) => trim(x, depth + 1));
  if (v && typeof v === "object") { if (depth > 6) return "…"; const o = {}; for (const k of Object.keys(v)) o[k] = trim(v[k], depth + 1); return o; }
  return v;
};
const body = (d) => { if (d == null) return null; if (typeof FormData !== "undefined" && d instanceof FormData) return `<multipart: ${[...d.keys()].join(", ")}>`; if (typeof d === "string") { try { return trim(JSON.parse(d)); } catch { return d.slice(0, 160); } } return trim(d); };
const push = (c, status, data) => {
  if (!c?.url?.includes("/disaster")) return;
  const q = c.params ? `?${new URLSearchParams(c.params)}` : "";
  entries = [{ id: ++seq, at: new Date().toISOString(), method: (c.method || "get").toUpperCase(), url: `${c.url}${q}`, status, ms: Math.round(performance.now() - (c.meta?.t0 ?? performance.now())), req: body(c.data), res: trim(data) }, ...entries].slice(0, 30);
  emit();
};
api.interceptors.request.use((c) => { c.meta = { t0: performance.now() }; return c; });
api.interceptors.response.use((r) => { push(r.config, r.status, r.data); return r; }, (e) => { push(e.config, e.response?.status || 0, e.response?.data || { error: e.message }); return Promise.reject(e); });

export const useApiLog = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => entries);
export const clearApiLog = () => { entries = []; emit(); };
